// RobotDex configuration.
// Paste your WalletConnect (Reown Cloud) Project ID from https://cloud.reown.com
// and your admin wallet addresses below. These are public values, safe in code.

export const WALLETCONNECT_PROJECT_ID =
  (import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string) ||
  "2b1da4c483e989d31e60794a71ae287a";

// Comma-separated admin wallet addresses (lowercased at runtime)
const ADMIN_ADDRESSES_RAW =
  "0xD5DDc2705f031Aeb3dF6FC59094cE996DF1F8841";

export const ADMIN_ADDRESSES = ADMIN_ADDRESSES_RAW.split(",")
  .map((a) => a.trim().toLowerCase())
  .filter(Boolean);

export const isAdminWallet = (address?: string | null) =>
  !!address && ADMIN_ADDRESSES.includes(address.toLowerCase());

export const APP_NAME = "RobotDex";
export const APP_URL = "https://robotdex.xyz";
export const APP_DESCRIPTION =
  "RobotDex - user-friendly NFT marketplace on Robinhood Chain & all EVM networks. Create, mint, buy, sell and list NFTs, fully on-chain.";

// Robinhood Chain Mainnet (EVM-compatible, native currency ETH)
export const ROBINHOOD_CHAIN = {
  id: 626, // placeholder — update when official chain ID is announced
  name: "Robinhood Chain Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.robinhoodchain.xyz"] } },
  blockExplorers: {
    default: { name: "RobinhoodScan", url: "https://explorer.robinhoodchain.xyz" },
  },
} as const;

// Default payment network (Base mainnet)
export const DEFAULT_CHAIN_ID = 8453;
